import React from 'react';
import './Textagenda.css';

const Textagenda= () => {
    return (
        <div className='mere2025'>

        <div className='containerA2025'>
            
            <div className='barres2025'>
            <div className='trait12025'></div>
            <div className='trait22025'></div>
            </div>
            <div className='titre2025'>
                <h1>AGENDA </h1>
            </div>
            <div className='ligne2025'>
            </div>
            </div>
            
   
    </div>
    
    );
};

export default Textagenda;
